module.exports = __webpack_public_path__ + "static/media/Overall.cbbe269c.png";